import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.support.'

@vsingleton()
export class AdminFaqRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'faqs.'

  store() {
    return this.ziggyRoute('store')
  }

  update(id: number) {
    return this.ziggyRoute('update', id)
  }

  destroy(id: number) {
    return this.ziggyRoute('destroy', id)
  }

  search() {
    return this.ziggyRoute('search')
  }

}
